import { configureStore } from '@reduxjs/toolkit'
import depositNotiSlice from './slices/depositNotiSlice'

export const store = configureStore({
  reducer: {
     depositNotiCount: depositNotiSlice,
  },
})